import React, { FC, useCallback, useMemo } from 'react';
import { Button } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/en'; // Import locale data
import 'dayjs/locale/es';
import isoWeek from 'dayjs/plugin/isoWeek';
dayjs.extend(isoWeek);

type Props = {
  value?: number[];
  onChange?: (value: number[]) => void;
};

export const DaySelect: FC<Props> = (props) => {
  const value = useMemo(() => props.value ?? [], [props.value]);
  const { onChange } = props;
  const startOfWeek = dayjs().startOf('week');
  const handleClick = useCallback(
    (day: number) => {
      if (value.includes(day)) {
        onChange?.(value.filter((v) => v !== day));
      } else {
        onChange?.([...value, day].sort());
      }
    },
    [onChange, value],
  );
  return (
    <div className="flex gap-2">
      {[0, 1, 2, 3, 4, 5, 6]
        .map((d) => [d, startOfWeek.add(d, 'd').isoWeekday() % 7])
        .map((d) => (
          <Button
            key={d[1]}
            shape="circle"
            type={value.includes(d[1]) ? 'primary' : 'default'}
            onClick={() => handleClick(d[1])}
          >
            {startOfWeek.add(d[0], 'd').format('dd')}
          </Button>
        ))}
    </div>
  );
};
